// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Fonts/ProximaSoft-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Fonts/ProximaSoft-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/green.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/line.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/bLine.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Proxima Soft";
  src:
    local("Proxima Soft SemiBold"),
    local("Proxima-Soft-SemiBold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 600;
  font-style: normal;
}

/* Layout: */
.main_container {
  font-family: "Proxima Soft", sans-serif !important;
  background: rgba(255, 255, 255, 1);
  overflow-x: hidden !important;
}

p {
  margin-bottom: 10px;
}

.col-main {
  flex: 1 1;
}

/* Responsive: */

@media only screen and (min-width: 1100px) {
  .layout {
    display: flex;
  }
}

.two-col-container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

.col {
  padding: 1em;
  margin: 0 2px 2px 0;
  height: calc(100vh - 5px);
  padding: 50px 120px 0px 120px;
  height: 100%;
}

.left {
  font-family: "Proxima Soft", sans-serif !important;
  display: flex;
  flex-direction: column;
  position: relative;
  height: calc(100vh - 5px);
}

.right {
  font-family: "Proxima Soft", sans-serif !important;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 15px -10px rgba(0, 0, 0, 0.75);
  position: relative;
  height: calc(106vh - 5px);
  /* background-color: red;
    width: 100%; */
  justify-content: center;
  margin-top: -50px;
}

.JK_logo {
  width: 200px;
}

.tag_line {
  font-size: 14px !important;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.1599999964237213px;
  text-align: left;
  font-size: 20px;
  margin-top: 30px;
}

.gradient {
  background: linear-gradient(179deg, #4273b8 50%, #34a853 50%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.label_head {
  font-size: 35px !important;
  font-weight: 500;
  line-height: 60px;
  letter-spacing: 0px;
  text-align: left;
  background: rgba(66, 66, 66, 1);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.label_desc {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1599999964237213px;
  text-align: left;
  background: rgba(106, 106, 106, 1);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.two-column {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;


}
.green-redial{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100% 40%;
  background-position: bottom;
  background-repeat: no-repeat;
}

.two-column .ant-checkbox-wrapper span {
  color: #878787 !important;
  font-weight: 300 !important;
  font-family: "Proxima Soft", sans-serif !important;
}

.two-column span {
  color: #4273b8;
}

.ai_img img {
  width: 200px;
}

.login_icons {
  font-size: 35px !important;
  color: rgba(106, 106, 106, 1) !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
}

.right_ls {
  margin-left: 40px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: column;
}

.single_ls {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.single_ls p {
  margin: 0px 10px !important;
}

.ls_p1 {
  background: rgba(66, 66, 66, 1) !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  color: transparent !important;
}

.ls_p2 {
  background: rgba(106, 106, 106, 1);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.radial-lines {
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  height: 500px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
}

.blue-grad {
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  height: 500px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
}

.green-grad {
  position: absolute;
  bottom: 0px;
  left: -20px;
  width: 100%;
  height: 40%;
  /* background-image: url("../../assets/green.png"); */
  background-size: cover;
}

.radial-lines-r {
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
}

.background-color {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.welcome {
  font-family: "Proxima Soft", sans-serif !important;
  font-size: 56px;
  font-weight: 700;
  line-height: 80px;
  letter-spacing: 0px;
  text-align: center;
  background: linear-gradient(93.04deg, #4273b8 4.29%, #4db748 92.42%);
  -webkit-background-clip: text !important;
  background-clip: text !important;
  color: transparent !important;
  z-index: 1;
}

.jakmet {
  font-family: "Proxima Soft", sans-serif !important;
  font-size: 56px;
  font-weight: 600;
  line-height: 80px;
  letter-spacing: 0px;
  text-align: center;
  background: rgba(78, 78, 78, 1);
  -webkit-background-clip: text !important;
  background-clip: text !important;
  color: transparent !important;
  z-index: 1;
}

.login_btn_cont {
  display: flex;
  justify-content: space-evenly;
  width: 80%;
  margin: 20px auto;
  margin-top: 30px;
}

/* Responsive adjustments for smaller screens */
@media (max-width: 768px) {
  .login_btn_cont {
    width: 90%;
    /* Adjust width for smaller screens */
    flex-wrap: wrap;
    /* Allow items to wrap */
  }
}
.create{
  display: flex;
  position: absolute;
  right: 10px;
  top: 59px;
}
.create .ant-btn {
  border: 1px solid rgba(157, 182, 218, 1) !important;
  padding: 12px 45px !important;
  height: auto !important;
  border-radius: 6px !important;
  color: #4a79bb !important;
}

.signInFull {
  display: flex;
  justify-content: center;
  margin: 0px auto;
  width: 100%;
}

.fullWidth {
  width: 92%;
}

.login-input .ant-input {
  width: 92%;
  height: 50px;
}

.signin .ant-btn {
  background: rgba(66, 115, 184, 1) !important;
  padding: 12px 60px !important;
  height: auto !important;
  border-radius: 6px !important;
  color: white !important;
}

.google {
  display: flex;
  justify-content: center;
  width: 80%;
  margin: 20px auto;
  margin-bottom: 20px;
}

.fb {
  display: flex;
  justify-content: center;
  width: 80%;
  margin: 20px auto;
  margin-bottom: 150px;
}

.google .ant-btn {
  padding: 12px 120px !important;
  height: auto !important;
  border-radius: 6px !important;
  color: rgba(78, 78, 78, 1) !important;
}

.google .ant-btn svg {
  margin-right: 10px;
  vertical-align: text-bottom !important;
}

.fb .ant-btn {
  padding: 12px 112px !important;
  height: auto !important;
  border-radius: 6px !important;
  color: rgba(78, 78, 78, 1) !important;
}

.fb .ant-btn svg {
  color: #517ebe !important;
  margin-right: 10px;
  vertical-align: text-bottom !important;
}

.or-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  /* Adjust margin as needed */
}

.divider-line-l {
  flex: 1 1;
  height: 1px;
  background-color: #e1e1e1;
  margin: 0 5px 0 96px;
  /* Divider line color */
}

.divider-line-r {
  flex: 1 1;
  height: 1px;
  background-color: #e1e1e1;
  margin: 0 5px;
  margin: 0 96px 0 5px;
  /* Divider line color */
}

.or-text {
  padding: 0 10px;
  /* Adjust padding around the "OR" text */
  font-weight: bold;
  /* Adjust font weight as needed */
}

.social {
  width: 80%;
  height: auto;

  /* margin: 10% 25% 0% 25%;
   */
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}

@media screen and (max-width: 1100px) {
  .left,
  .right {
    padding: 30px;
  }

  .left {
    height: max-content;
  }
}

.terms-link {
  margin-top: 10px;
  color: #4a79bb;
  cursor: pointer;
  align-self: center;
  margin-right: 15px;
}

.terms-link:hover {
  text-decoration: underline;
}

`, "",{"version":3,"sources":["webpack://./src/Screens/Login/style.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B;;;;0DAIoE;EACpE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kDAAkD;EAClD,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA,gBAAgB;;AAEhB;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,kBAAkB;EAClB,yBAAyB;EACzB;kBACgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;;;AAGlB;AACA;EACE,yDAA+C;EAC/C,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,yDAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,yDAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;EACX,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,yDAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;EACpE,wCAAwC;EACxC,gCAAgC;EAChC,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,wCAAwC;EACxC,gCAAgC;EAChC,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE;IACE,UAAU;IACV,qCAAqC;IACrC,eAAe;IACf,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,mDAAmD;EACnD,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,YAAY;;EAEZ;IACE;EACF,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["@font-face {\n  font-family: \"Proxima Soft\";\n  src:\n    local(\"Proxima Soft SemiBold\"),\n    local(\"Proxima-Soft-SemiBold\"),\n    url(\"../../assets/Fonts/ProximaSoft-SemiBold.woff2\") format(\"woff2\"),\n    url(\"../../assets/Fonts/ProximaSoft-SemiBold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n/* Layout: */\n.main_container {\n  font-family: \"Proxima Soft\", sans-serif !important;\n  background: rgba(255, 255, 255, 1);\n  overflow-x: hidden !important;\n}\n\np {\n  margin-bottom: 10px;\n}\n\n.col-main {\n  flex: 1;\n}\n\n/* Responsive: */\n\n@media only screen and (min-width: 1100px) {\n  .layout {\n    display: flex;\n  }\n}\n\n.two-col-container {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.col {\n  padding: 1em;\n  margin: 0 2px 2px 0;\n  height: calc(100vh - 5px);\n  padding: 50px 120px 0px 120px;\n  height: 100%;\n}\n\n.left {\n  font-family: \"Proxima Soft\", sans-serif !important;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: calc(100vh - 5px);\n}\n\n.right {\n  font-family: \"Proxima Soft\", sans-serif !important;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 15px -10px rgba(0, 0, 0, 0.75);\n  position: relative;\n  height: calc(106vh - 5px);\n  /* background-color: red;\n    width: 100%; */\n  justify-content: center;\n  margin-top: -50px;\n}\n\n.JK_logo {\n  width: 200px;\n}\n\n.tag_line {\n  font-size: 14px !important;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: 0.1599999964237213px;\n  text-align: left;\n  font-size: 20px;\n  margin-top: 30px;\n}\n\n.gradient {\n  background: linear-gradient(179deg, #4273b8 50%, #34a853 50%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.label_head {\n  font-size: 35px !important;\n  font-weight: 500;\n  line-height: 60px;\n  letter-spacing: 0px;\n  text-align: left;\n  background: rgba(66, 66, 66, 1);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.label_desc {\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0.1599999964237213px;\n  text-align: left;\n  background: rgba(106, 106, 106, 1);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.two-column {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 50px;\n\n\n}\n.green-redial{\n  background-image: url(\"../../assets/green.png\");\n  background-size: 100% 40%;\n  background-position: bottom;\n  background-repeat: no-repeat;\n}\n\n.two-column .ant-checkbox-wrapper span {\n  color: #878787 !important;\n  font-weight: 300 !important;\n  font-family: \"Proxima Soft\", sans-serif !important;\n}\n\n.two-column span {\n  color: #4273b8;\n}\n\n.ai_img img {\n  width: 200px;\n}\n\n.login_icons {\n  font-size: 35px !important;\n  color: rgba(106, 106, 106, 1) !important;\n  -webkit-background-clip: text !important;\n  background-clip: text !important;\n}\n\n.right_ls {\n  margin-left: 40px;\n  display: flex;\n  justify-content: space-around;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.single_ls {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.single_ls p {\n  margin: 0px 10px !important;\n}\n\n.ls_p1 {\n  background: rgba(66, 66, 66, 1) !important;\n  -webkit-background-clip: text !important;\n  background-clip: text !important;\n  color: transparent !important;\n}\n\n.ls_p2 {\n  background: rgba(106, 106, 106, 1);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.radial-lines {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 500px;\n  height: 500px;\n  background-image: url(\"../../assets/line.png\");\n  background-size: cover;\n}\n\n.blue-grad {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 500px;\n  height: 500px;\n  background-image: url(\"../../assets/blue.png\");\n  background-size: cover;\n}\n\n.green-grad {\n  position: absolute;\n  bottom: 0px;\n  left: -20px;\n  width: 100%;\n  height: 40%;\n  /* background-image: url(\"../../assets/green.png\"); */\n  background-size: cover;\n}\n\n.radial-lines-r {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 500px;\n  height: 100%;\n  background-image: url(\"../../assets/bLine.png\");\n  background-size: cover;\n}\n\n.background-color {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.welcome {\n  font-family: \"Proxima Soft\", sans-serif !important;\n  font-size: 56px;\n  font-weight: 700;\n  line-height: 80px;\n  letter-spacing: 0px;\n  text-align: center;\n  background: linear-gradient(93.04deg, #4273b8 4.29%, #4db748 92.42%);\n  -webkit-background-clip: text !important;\n  background-clip: text !important;\n  color: transparent !important;\n  z-index: 1;\n}\n\n.jakmet {\n  font-family: \"Proxima Soft\", sans-serif !important;\n  font-size: 56px;\n  font-weight: 600;\n  line-height: 80px;\n  letter-spacing: 0px;\n  text-align: center;\n  background: rgba(78, 78, 78, 1);\n  -webkit-background-clip: text !important;\n  background-clip: text !important;\n  color: transparent !important;\n  z-index: 1;\n}\n\n.login_btn_cont {\n  display: flex;\n  justify-content: space-evenly;\n  width: 80%;\n  margin: 20px auto;\n  margin-top: 30px;\n}\n\n/* Responsive adjustments for smaller screens */\n@media (max-width: 768px) {\n  .login_btn_cont {\n    width: 90%;\n    /* Adjust width for smaller screens */\n    flex-wrap: wrap;\n    /* Allow items to wrap */\n  }\n}\n.create{\n  display: flex;\n  position: absolute;\n  right: 10px;\n  top: 59px;\n}\n.create .ant-btn {\n  border: 1px solid rgba(157, 182, 218, 1) !important;\n  padding: 12px 45px !important;\n  height: auto !important;\n  border-radius: 6px !important;\n  color: #4a79bb !important;\n}\n\n.signInFull {\n  display: flex;\n  justify-content: center;\n  margin: 0px auto;\n  width: 100%;\n}\n\n.fullWidth {\n  width: 92%;\n}\n\n.login-input .ant-input {\n  width: 92%;\n  height: 50px;\n}\n\n.signin .ant-btn {\n  background: rgba(66, 115, 184, 1) !important;\n  padding: 12px 60px !important;\n  height: auto !important;\n  border-radius: 6px !important;\n  color: white !important;\n}\n\n.google {\n  display: flex;\n  justify-content: center;\n  width: 80%;\n  margin: 20px auto;\n  margin-bottom: 20px;\n}\n\n.fb {\n  display: flex;\n  justify-content: center;\n  width: 80%;\n  margin: 20px auto;\n  margin-bottom: 150px;\n}\n\n.google .ant-btn {\n  padding: 12px 120px !important;\n  height: auto !important;\n  border-radius: 6px !important;\n  color: rgba(78, 78, 78, 1) !important;\n}\n\n.google .ant-btn svg {\n  margin-right: 10px;\n  vertical-align: text-bottom !important;\n}\n\n.fb .ant-btn {\n  padding: 12px 112px !important;\n  height: auto !important;\n  border-radius: 6px !important;\n  color: rgba(78, 78, 78, 1) !important;\n}\n\n.fb .ant-btn svg {\n  color: #517ebe !important;\n  margin-right: 10px;\n  vertical-align: text-bottom !important;\n}\n\n.or-divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px 0;\n  /* Adjust margin as needed */\n}\n\n.divider-line-l {\n  flex: 1;\n  height: 1px;\n  background-color: #e1e1e1;\n  margin: 0 5px 0 96px;\n  /* Divider line color */\n}\n\n.divider-line-r {\n  flex: 1;\n  height: 1px;\n  background-color: #e1e1e1;\n  margin: 0 5px;\n  margin: 0 96px 0 5px;\n  /* Divider line color */\n}\n\n.or-text {\n  padding: 0 10px;\n  /* Adjust padding around the \"OR\" text */\n  font-weight: bold;\n  /* Adjust font weight as needed */\n}\n\n.social {\n  width: 80%;\n  height: auto;\n\n  /* margin: 10% 25% 0% 25%;\n   */\n  margin-top: 20px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n\n@media screen and (max-width: 1100px) {\n  .left,\n  .right {\n    padding: 30px;\n  }\n\n  .left {\n    height: max-content;\n  }\n}\n\n.terms-link {\n  margin-top: 10px;\n  color: #4a79bb;\n  cursor: pointer;\n  align-self: center;\n  margin-right: 15px;\n}\n\n.terms-link:hover {\n  text-decoration: underline;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
